var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useMemo, useReducer, useCallback, useEffect } from "react";
import styled from "styled-components";
import { Day, Months } from ".";
var DayWrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var theme = _a.theme;
    return "\n    position: absolute;\n    height: 250px;\n    width: 250px;\n    background: ".concat(theme.bgContent(), ";\n    top: 100%;\n    z-index: 1;\n    display: grid;\n    grid-template-columns: repeat(7, 1fr);\n    color: ").concat(theme.colorContent(), ";\n    grid-gap: 3px;\n    padding: 3px;\n    border: 1px solid ").concat(theme.borderContent(), ";\n  ");
});
var Text = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n"], ["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n"])));
var MonthYear = styled.button(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  grid-column: 2/7;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background-color: transparent;\n  border: none;\n  color: inherit;\n  cursor: pointer;\n"], ["\n  grid-column: 2/7;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background-color: transparent;\n  border: none;\n  color: inherit;\n  cursor: pointer;\n"])));
var Seperator = styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  border-top: 1px solid;\n  grid-column: 1/8;\n"], ["\n  border-top: 1px solid;\n  grid-column: 1/8;\n"])));
var getDaysInMonth = function (year, month) {
    return new Date(year, month + 1, 0).getDate();
};
var firstDayInMonth = function (year, month) {
    return new Date(year, month, 1).getDay();
};
var isSameDay = function (date1, date2) {
    if (date1.getDate() === date2.getDate() &&
        date1.getMonth() === date2.getMonth() &&
        date1.getFullYear() === date2.getFullYear()) {
        console.log(date1, date2);
        return true;
    }
    return false;
};
var dispatchFn = function (state, action) {
    switch (action.type) {
        case "SET_VALUE":
            return { currValue: action.payload, displayValue: action.payload };
        case "SET_DISPLAY":
            return __assign(__assign({}, state), { displayValue: action.payload });
        default:
            return __assign({}, state);
    }
};
export var Calendar = function (_a) {
    var value = _a.value, onChange = _a.onChange;
    var _b = useReducer(dispatchFn, { currValue: value, displayValue: value }), _c = _b[0], currValue = _c.currValue, displayValue = _c.displayValue, dispatch = _b[1];
    useEffect(function () {
        if (value !== currValue) {
            dispatch({ type: "SET_VALUE", payload: value });
        }
    }, [value, currValue]);
    var handlePrevMonth = useCallback(function () {
        dispatch({ type: "SET_DISPLAY", payload: new Date(displayValue.getFullYear(), displayValue.getMonth() - 1, 1) });
    }, [displayValue]);
    var handleNextMonth = useCallback(function () {
        dispatch({ type: "SET_DISPLAY", payload: new Date(displayValue.getFullYear(), displayValue.getMonth() + 1, 1) });
    }, [displayValue]);
    var handleDayClick = useCallback(function (date, e) {
        dispatch({ type: "SET_VALUE", payload: date });
        if (onChange) {
            onChange(date, e);
        }
    }, [onChange]);
    var Days = useMemo(function () {
        var year = displayValue.getFullYear();
        var month = displayValue.getMonth();
        var prevDays = getDaysInMonth(year, month - 1);
        var numDays = getDaysInMonth(year, month);
        var firstDay = firstDayInMonth(year, month);
        var days = [];
        var daysRemaining = 42; // 6 rows
        var offMonthOpacity = 0.7;
        if (firstDay === 0) {
            for (var i = 6; i >= 0; i--) {
                var date = new Date(year, month - 1, prevDays - i);
                days.push(React.createElement(Day, { key: date.toISOString(), value: date, opacity: offMonthOpacity, onClick: handleDayClick }));
                daysRemaining--;
            }
        }
        else {
            for (var i = 1; i <= firstDay; i++) {
                var date = new Date(year, month - 1, prevDays - (firstDay - i));
                days.push(React.createElement(Day, { key: date.toISOString(), value: date, opacity: offMonthOpacity, onClick: handleDayClick }));
                daysRemaining--;
            }
        }
        for (var i = 1; i <= numDays; i++) {
            var date = new Date(year, month, i);
            days.push(React.createElement(Day, { key: date.toISOString(), value: date, onClick: handleDayClick, isActive: isSameDay(currValue, date) }));
            daysRemaining--;
        }
        for (var i = daysRemaining - 1; i >= 0; i--) {
            var date = new Date(year, month + 1, daysRemaining - i);
            days.push(React.createElement(Day, { key: date.toISOString(), value: date, opacity: offMonthOpacity, onClick: handleDayClick }));
        }
        return days;
    }, [displayValue, handleDayClick, currValue]);
    var handleShowMonthYear = useCallback(function () { }, []);
    return (React.createElement(DayWrapper, null,
        React.createElement(Text, { onClick: handlePrevMonth }, "<<"),
        React.createElement(MonthYear, { type: "button", onClick: handleShowMonthYear },
            Months[displayValue.getMonth()],
            " ",
            displayValue.getFullYear()),
        React.createElement(Text, { onClick: handleNextMonth }, ">>"),
        React.createElement(Text, null, "Su"),
        React.createElement(Text, null, "Mo"),
        React.createElement(Text, null, "Tu"),
        React.createElement(Text, null, "We"),
        React.createElement(Text, null, "Th"),
        React.createElement(Text, null, "Fr"),
        React.createElement(Text, null, "Sa"),
        React.createElement(Seperator, null),
        Days));
};
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
